export default __webpack_public_path__ + "static/media/Content1.047778ac.png";